export enum CampaignType {
  ITEM = 'CAMPAIGN_ITEM',
  DISCOUNT = 'CAMPAIGN_DISCOUNT',
  DISCOUNT_PERCENTAGE = 'CAMPAIGN_DISCOUNT_PERCENTAGE',
  PLATFORM = 'PLATFORM',
}

export type CouponDiscount = {
  costLimit: number;
  discount: number;
};

export type CouponDiscountPercentage = {
  costLimit: number;
  percentage: number;
  discountLimit: number;
};

export type CouponItem = {
  costLimit: number;
  name: string;
  description: string;
};

export type CampaignCondition = Partial<{
  [CampaignType.DISCOUNT]: CouponDiscount;
  [CampaignType.DISCOUNT_PERCENTAGE]: CouponDiscountPercentage;
  [CampaignType.ITEM]: CouponItem;
  [CampaignType.PLATFORM]: undefined;
}>;

export type Coupon = {
  id: string;
  stores: Array<string>; // store ids of available store
  startDate: string; // iso time string
  endDate: string; // iso time string
  allowDisplay: boolean;
  name: string;
  description: string;
  note: string;
  code: string;
  type: CampaignType;
  condition: CampaignCondition;
};
